import styled from 'styled-components'
import { Grid } from '@material-ui/core'

export const Wrapper = styled(Grid)`
  margin-bottom: 0.8rem;
`

export const GridHorizontalDate = styled(Grid)``
